(ns dashboard.entity.question.answer-scope
  (:require [re-frame.core :as rf]
            ["react" :as react]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [dashboard.components.combobox :as combobox]
            [io.repliance.schemas.core :as schemas]))

(rf/reg-sub
  ::answer-scopes
  (fn [db _]
    (:answer-scopes db)))

(rf/reg-event-fx
  ::get
  (fn [_ _]
    {:http-xhrio {:method :get
                  :uri (str "/api/questions/answer-scope")
                  :format http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :on-success [::get-success]
                  :on-failure [::ui/set-error "Failed to get answer scopes"]}}))

(rf/reg-event-db
  ::get-success
  (fn [db [_ answer-scopes]]
    (assoc db :answer-scopes answer-scopes)))

(def default-answer-scope-options
  [schemas/not-yet-evaluated-answer-scope
   schemas/completed-by-analyst-answer-scope
   "Answer Provided, Client Reviewed"
   "Novel Information Needed"
   "Out of Scope - Legal"
   "Out of Scope - Compliance"
   "Out of Scope - Product"
   "Out of Scope - Sales"
   "No Answer Requested"
   "Rescope requested"])

(defn AnswerScope [{:keys [on-commit initial-answer-scope tooltip-suffix hide-title disabled]}]
  (let [answer-scopes @(rf/subscribe [::answer-scopes])
        [answer-scope set-answer-scope] (react/useState initial-answer-scope)
        options (let [defaults (set default-answer-scope-options)]
                  (into default-answer-scope-options
                        (keep (fn [{:keys [content]}]
                                (when-not (contains? defaults content)
                                  content)))
                        answer-scopes))]
    [:div
     {:class (when disabled [:no-pointer-events])
      :style (when disabled {:opacity 0.5})}
     (when-not hide-title "Answer scope")
     [:f> combobox/combobox
      {:options options
       :disabled disabled
       :value answer-scope
       :on-set-value set-answer-scope
       :on-commit #(on-commit %)
       :validation-error nil
       :editable? true
       :title (str "Select the scope of work that answering this question requires.\n\n"
                   "You can also type into the input field and hit Enter to submit, if the options don't meet your needs."
                   (when tooltip-suffix
                     (str "\n\n" tooltip-suffix)))
       :up? false}]]))
